import { render } from "./DrawZones.vue?vue&type=template&id=5597e8a2&scoped=true"
import script from "./DrawZones.vue?vue&type=script&lang=js"
export * from "./DrawZones.vue?vue&type=script&lang=js"

import "./DrawZones.vue?vue&type=style&index=0&id=5597e8a2&lang=scss&scoped=true"

import exportComponent from "/builds/oleksandr.makhovskyi/admin-template/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5597e8a2"]])

export default __exports__